import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import agilite from './modules/agilite';

const store = new Vuex.Store({
	modules : {
		agilite
	},
});

export default store;
